module.exports = "<div class=\"h5 mt-4 mb-0\">\n    <div><small>Confirmation code:</small>\n        <strong>{{ctrl.order.confirmationCode}}</strong>\n    </div>\n    <div><small>Order:</small>\n        <strong>#{{ctrl.orderNumber}}</strong>\n    </div>\n    <div><small>Order placed at:</small>\n        <strong>{{ctrl.originalPlacedAt}}</strong>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/orderNumbers.html
// module id = 763
// module chunks = 0